const noticeFields = [
  {
    id: "path",
    numeric: false,
    disablePadding: false,
    label: "File",
    width: "auto",
    type: "file",
  },
  {
    id: "title",
    numeric: false,
    disablePadding: false,
    label: "Title",
    width: "auto",
  },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: false,
    label: "Date",
    width: "80",
    type: "date",
  },
  {
    id: "note",
    numeric: false,
    disablePadding: false,
    label: "note",
    width: "auto",
  },
];

export default noticeFields;
